module.exports = __webpack_public_path__ + "static/media/ravelry.77d4fba7.svg";